export default __webpack_public_path__ + "static/media/watermark-230.e145dbab.wav";